// extracted by mini-css-extract-plugin
export default {"fadeOutControllers":"fadeoutcontrollers_fadeOutControllers__2Tjkc"};